// Mirrors backend/core/delegate_status.py — keep the two in step.
//
// Three backend dashboards and this page all counted `status === "confirmed"`,
// a value nothing writes, so every "confirmed" figure read zero. A delegate
// holds their place once they are registered, paid, or through the door; the
// legacy literal is still counted so no historical row is reclassified.
export const CONFIRMED_STATUSES = ['registered', 'paid', 'checked_in', 'confirmed'];

export const isConfirmed = (status) => CONFIRMED_STATUSES.includes(status);

// Confirmed, but not yet through the door.
export const isAwaitingCheckIn = (status) =>
  isConfirmed(status) && status !== 'checked_in';

export const matchesStatusFilter = (status, filter) => {
  if (filter === 'all') return true;
  if (filter === 'confirmed') return isConfirmed(status);
  if (filter === 'pending') return status === 'pending' || status === 'pending_payment';
  return status === filter;
};
